import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Bambora_credit_card } from '../models/accounting/banking/bambora_credit_card';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class BamboraPaymentCardService {

  constructor(private http: HttpClient) { }

  get_list(organizer_id: string): Promise<Bambora_credit_card[]> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'accounting/banking/bambora_credit_cards/organizer_id/' + organizer_id).subscribe((response: any) => {
        if (response.type === 'bambora_payment_profiles' && response.data) {
          resolve(response.data);
        } else {
          reject(response);
        }
      },
        error_response => {
          if (error_response instanceof HttpErrorResponse) {
            reject(error_response.error);
          }
          reject(error_response);
        });
    });
  }

  create(organizer_id: string, card: any): Promise<Bambora_credit_card> {
    const post_data = {
      data: {
        type: 'bambora_credit_card_request',
        attributes: { bambora_credit_card: card, organizer_id: organizer_id }
      }
    };

    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'accounting/banking/bambora_credit_cards',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response.data && response.type === 'bambora_payment_profile') {
            resolve(response.data);
          } else {
            reject(response.text ? response.text : response);
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error.data ? error.data : error);
          }
        });
    });
  }

}
